import React from 'react';
import './Clients.css';

function Clients() {
  return (
    <div className="clients">
      <h2>Select Clients</h2>
      <ul>
        <li>Houston Chronicle</li>
        <li>Monster.com</li>
        <li>Comcast Spotlight</li>
         
      </ul>
    </div>
  );
}

export default Clients;
